angular.module('lsnBase.object', [
  'lsnBase.deepExtend'
]);